import React from "react";
import aboutImage from "../../assets/images/Founder-image/founder.jpeg";

const AboutSection = () => {
    const COLORS = {
      bgPrimary: "#0B1C2D",   // Deep Navy
      bgSecondary: "#13293D", // Slightly Lighter Navy
      gold: "#C6A75E",        // Premium Gold
      textLight: "#EAEAEA",
    };

  const services = [
    { id: "01", title: "Corporate Law", desc: "Expert guidance for national and international wealth clients." },
    { id: "02", title: "Civil Litigation", desc: "Two decades of mastery in the Supreme Court and High Courts." },
    { id: "03", title: "Private Wealth", desc: "Protecting the future of our clients with strategic integrity." },
  ];

  return (
    <section className="py-12 md:py-20 px-4 md:px-10 ">
      {/* --- THE MASTER SECTION CARD --- */}
      <div 
        className="max-w-7xl mx-auto overflow-hidden rounded-xl border border-white/10 shadow-2xl relative"
        style={{ backgroundColor: COLORS.bgSecondary }}
      >
        {/* Background Decorative Element */}
        <div className="absolute top-0 right-0 p-10 opacity-[0.03] select-none pointer-events-none">
          <h1 className="text-[15vw] font-black leading-none">LAW</h1>
        </div>

        <div className="flex flex-col lg:flex-row">
          
          {/* LEFT: IMAGE COLUMN (Fixed Height on Mobile, Full on Desktop) */}
        <div className="lg:w-5/12 relative overflow-hidden group">
  <img
    src={aboutImage}
    alt="Founder"
    /* Saare filter aur hover effects hata diye hain, ab image natural dikhegi */
    className="w-full h-full min-h-[400px] object-cover"
  />
  
  {/* Overlay Gradient ko thoda subtle kar diya hai taaki left side se image saaf dikhe */}
  <div className="absolute inset-0 bg-gradient-to-r from-[#13293D]/20 to-transparent" />
  
  {/* Experience Label - Ise blur backdrop ke saath rakha hai taaki text readable rahe */}
  <div className="absolute bottom-0 left-0 right-0 p-8 backdrop-blur-sm bg-black/20 border-t border-white/10">
    <div className="flex items-center gap-4">
      <span className="text-5xl font-bold" style={{ color: COLORS.gold }}>20+</span>
      <p className="text-[10px] uppercase tracking-[0.3em] leading-tight text-white font-semibold">
        Years of Unmatched <br />Legal Mastery
      </p>
    </div>
  </div>
</div>

          {/* RIGHT: CONTENT COLUMN */}
          <div className="lg:w-7/12 p-8 md:p-16 flex flex-col justify-center relative">
            
            <div className="flex items-center gap-3 mb-8">
              <div className="h-[1px] w-8 bg-white/30" />
              <span className="text-[11px] font-bold uppercase tracking-[0.5em]" style={{ color: COLORS.gold }}>
                Nyaysakti Firm
              </span>
            </div>

            <h2 className="text-4xl md:text-6xl font-bold text-white mb-8 leading-tight">
              Crafting <span className=" font-light opacity-70">Justice</span> <br /> 
              Through Expertise.
            </h2>

            <div className="space-y-6 text-gray-300 max-w-xl">
              <p className="text-lg leading-relaxed border-l-2 pl-6" style={{ borderColor: COLORS.gold }}>
                Based in New Delhi, we provide independent, elite legal services with a 
                focus on strategic integrity and client protection.
              </p>
              
              {/* Internal Stats Grid */}
              <div className="grid grid-cols-2 gap-10 py-8 border-y border-white/5">
                <div>
                  <p className="text-4xl font-bold text-white">500+</p>
                  <p className="text-[20px] uppercase tracking-widest text-gray-400 font-bold">Success Stories</p>
                </div>
                <div>
                  <p className="text-4xl font-bold text-white">98%</p>
                  <p className="text-[20px] uppercase tracking-widest text-gray-400 font-bold">Client Retention</p>
                </div>
              </div>
            </div>

           {/* LOWER GRID: SERVICE CARDS (Embedded) */}
<div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-12 -mx-8 md:-mx-16 border-t border-white/5">
  {services.map((s) => (
    <div 
      key={s.id} 
      className="p-8 hover:bg-white/[0.03] transition-colors border-r border-white/5 last:border-r-0"
    >
      {/* ID Number Highlight */}
      <span 
        className="block text-sm font-extrabold mb-4 opacity-90" 
        style={{
          color: COLORS.gold,
          fontSize: "1.2rem",          // bigger number
          textShadow: "0 0 8px rgba(255, 215, 180, 0.6)" // glow effect
        }}
      >
        [{s.id}]
      </span>

      {/* Title */}
      <h4 className="text-white text-sm sm:text-base font-bold uppercase tracking-wider mb-2">
        {s.title}
      </h4>

      {/* Description */}
      <p className="text-gray-300 text-sm sm:text-[14px] leading-relaxed">
        {s.desc}
      </p>
    </div>
  ))}
</div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;